'use client'

import { motion } from 'framer-motion'
import { Sparkles, Check } from 'lucide-react'
import { AVAILABLE_FEATURES } from '@/hooks/useAppStore'

interface StepFuncionalidadesProps {
  featuresSelecionadas: string[]
  toggleFeature: (id: string) => void
  onSubmit: () => void
  onBack: () => void
}

export function StepFuncionalidades({ featuresSelecionadas, toggleFeature, onSubmit, onBack }: StepFuncionalidadesProps) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="w-full max-w-lg mx-auto">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-4 sm:mb-6">
        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg shadow-purple-500/30">
          <Sparkles size={24} strokeWidth={1.5} className="text-white" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold text-indigo-950 dark:text-white mb-2">O que seu site precisa ter?</h2>
        <p className="text-indigo-950/50 dark:text-white/50 text-sm">Selecione as funcionalidades desejadas</p>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="grid grid-cols-2 gap-1.5 sm:gap-2 mb-3 sm:mb-4">
        {AVAILABLE_FEATURES.map((feature) => {
          const isSelected = featuresSelecionadas.includes(feature.id)
          return (
            <button key={feature.id} onClick={() => toggleFeature(feature.id)} className={`p-2.5 sm:p-3 rounded-xl border text-left transition-all min-h-[44px] ${isSelected ? 'border-purple-500/50 bg-purple-500/10' : 'border-purple-500/20 dark:border-white/10 bg-white/85 dark:bg-white/5 hover:border-purple-500/30 dark:border-white/20'}`}>
              <div className="flex items-center gap-2">
                <div className={`w-6 h-6 rounded flex items-center justify-center transition-colors ${isSelected ? 'bg-purple-500' : 'border-2 border-purple-500/20 dark:border-white/10'}`}>
                  {isSelected && <Check size={12} className="text-white" />}
                </div>
                <span className={`text-xs sm:text-sm ${isSelected ? 'text-purple-400' : 'text-indigo-950/70 dark:text-white/70'}`}>{feature.label}</span>
              </div>
            </button>
          )
        })}
      </motion.div>
      <button onClick={onSubmit} className="w-full py-3.5 rounded-full font-medium text-sm bg-purple-600 hover:bg-purple-500 active:bg-purple-700 text-white shadow-lg shadow-purple-600/25 transition-all active:scale-[0.98]">
        {featuresSelecionadas.length > 0 ? `Continuar (${featuresSelecionadas.length} selecionadas)` : 'Continuar sem selecionar'}
      </button>
      <motion.button initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }} onClick={onBack} className="mt-4 w-full text-center text-sm text-indigo-950/40 dark:text-white/40 hover:text-indigo-950/60 dark:text-white/60 transition-colors">&larr; Voltar</motion.button>
    </motion.div>
  )
}
